import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from 'store/reducer';
import { useDispatch } from 'react-redux';

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
